import { render, staticRenderFns } from "./teacherTypeList.vue?vue&type=template&id=44971253&"
import script from "./teacherTypeList.vue?vue&type=script&lang=js&"
export * from "./teacherTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports